export const doc_artists_en = {
  title: "Artists",
  description: `Each album has an artist, it's the only required attribute besides the album name.
  
  Use the artist to represent bands, soloists, collaborations, or anything in between.
  
`
};
